import immutableUpdate from 'immutable-update'
import * as actions from "./actions";

const initialState = {
  userLoged: null,
  logged: false,
};

const reducers = {

  

  USER_LOGED: (state, action) => {


    return immutableUpdate(state, {
      userLoged: action.payload.data, logged: true
    });
  },

  CONFIRM_AUTH: (state, action) => {

    return immutableUpdate(state, {
      logged: action.payload.data.status, 
      userLoged: action.payload.data.data
    });
  },

  [actions.USER_LOGEDOUT]: (state, action) => {
    return {};
  },
  
};

const reducer = (state = initialState, action) =>
  reducers[action.type] ? reducers[action.type](state, action) : state;

export default reducer;
